import { ofType, ActionsObservable } from 'redux-observable';
import { map, mergeMap, flatMap } from 'rxjs/operators';
import { from } from 'rxjs';
import {format} from 'one-util-date';

import {
    setAction,
} from 'one-state-updateuserid';

import {
    addAction
} from 'one-state-error/src/actions';

import {
    ErrorObject
} from 'one-state-error/src/errorobject';
import axios from 'axios';
import { TransformResponse } from './transform';

export const enum Types {
    UPDATEAGENTID = 'one-state-updateuserid/fetch'
}

/**
 * This Fuction will fetch the data of agentid epic
 * from backend api and returns the response and calls
 * subsequent redux action
 * @param context contains the settings etc..
 */

export const fetchUpdateUserID = (context: any) => (
    (action$: ActionsObservable<any>) => {
        const errorTime = format(new Date(),'LT');
        const errorDate = format(new Date(),'LL');
        const { serverone,
            log,
            alertnotification,
            settings:
            {
                epicendpoints: { getepicuserid, apitoken },servers
            }
        } = context;
        const { locations = [] } = servers;
        return action$.pipe(
            ofType(Types.UPDATEAGENTID),
            //todo: to fix the type of Action
            mergeMap((action: any) => {
                /**
                 * @param dataresponse contains the Referrals Response
                 */
                let dataresponse: any = action.payload;
                const getRequest = (datares: any) => {
                   
                    if (datares) {
                        let headers = new Headers();
                        // todo: need to refractor to include authorization in interface
                        headers.set('Authorization', 'Basic ' + apitoken?.token);
                        const data = {
                            "epic_user": datares.epic_user,
                            "finesse_user": datares.finesse_user,
                            "five_nine_user": datares.five_nine_user,
                            "wxcc_user": datares.wxcc_user,
                            "force": true
                        }
                        const response = serverone.put({
                            path: getepicuserid,
                            data: data,
                            headers: headers
                        })
                            .then((responsefound: any) => responsefound)
                            .catch((responseresult: any) => {
                                      //Check the Side B server receive communication
                        if(locations?.length >= 2){
                            const receivecommTwo = locations[1]?.base+getepicuserid;
                            const token = 'Basic ' + apitoken?.token;
                            const response = axios.put(`${receivecommTwo}`,data,{ headers : {
                                'Accept': 'application/json',
                                'Authorization': token,
                                'Content-Type': 'text/plain'
                            }},)
                            .then((response: any) => {
                                log.debug('Update Epic UserID SUCCESS: ', 'Agenta health check passed with status code:', response)
                                return response;
                            })
                            .catch((response: any) => {
                                if(datares) {
                                    log.debug('Update Epic UserID ', 'Response', response);
                                    let alerterror: ErrorObject = {
                                        source: "Update Epic UserID",
                                        type: "error",
                                        status: 400,
                                        erroritems: [],
                                        error_date: errorDate,
                                        error_time: errorTime
                                    };
                                    
                                    // A brief description on how you can troubleshoot our two common errors seen here.
                                    console.error('Receive Communication ERROR: Unable to reach the Agenta server. If cert error (\'ERR_CERT_AUTHORITY_INVALID\'), browse the request URL and accept the certificate. If \'ERR_NAME_NOT_RESOLVED\', verify connection to UPMC server environment.');
                                    return alerterror;
                                }
                            });
                            return response;
                        }else {
                            log.error(
                                "ccw-gadget,agentid-epic",
                                "fetch-updateuserid-epic", {
                                responseresult
                            }
                            );  
                        }
                            })
                        return from(response)
                    } else {
                        return from([]);
                    }
                }
                //Calling getRequst function here
                //the reason is we need to use pipe function.
                return getRequest(dataresponse).
                    pipe(
                        map((response: any) => TransformResponse(response, context))).
                    pipe(
                        flatMap(response => {
                            const actions: any = [
                                setAction(response?.agentiddata[0])];
                            if (response.error) {
                                actions.push(addAction(response.error));
                            }
                            return actions;
                        })
                    )
            })
        )
    }
);


